import styled from '@emotion/styled';

export const Section = styled.section`
  padding-top: ${props => props.theme.spacing(20)};
  padding-bottom: ${props => props.theme.spacing(20)};
`;
